/** Helpers for GameSetup edit/copy hydration — games store `competition`, UI uses `competitionId`. */

import { Competition } from "../types/competition";

export type GameCompetitionSource = {
  competition?: Competition | string | null;
  competitionId?: string;
} | null;

/** Resolve a game-rule id from populated competition, raw ObjectId string, or competitionId. */
export function resolveCompetitionId(source?: GameCompetitionSource): string {
  if (!source) return "";
  const c = source.competition as any;
  if (typeof c === "string" && c) return String(c);
  if (c && c._id != null) return String(c._id);
  if (source.competitionId) return String(source.competitionId);
  return "";
}

export function resolveAttachedCompetition(
  competitionId: string | undefined,
  ...sources: GameCompetitionSource[]
): Competition | null {
  if (!competitionId) return null;
  const id = String(competitionId);
  for (const source of sources) {
    const competition = source?.competition;
    if (!competition || typeof competition === "string") continue;
    if (competition._id != null && String(competition._id) === id) return competition;
  }
  return null;
}
